import { Moment } from 'moment-timezone';
import { PetService } from '@spike/new-booking-model';
import { Product } from '@spike/product-model';
import AddOnService from '@spike/addon-service-model';

export enum wizardBooking {
    PetParent = 'petParent',
    Service = 'service',
    Staff = 'staff',
    Deposit = 'deposit',
    Notes = 'notes'
}

export enum itemTypes {
    addOn = 'add-on',
    product = 'product',
    custom = 'custom',
    service = 'service'
}

export enum versionPetAndServices {
    add = 'add',
    edit = 'edit',
    another = 'another'
}

export interface PetServiceWrapper extends PetService {
    duration?: Duration;
    beforePrice?: number;
}

export interface PetServiceTotal {
    price: number;
    durationInMinutes: number;
    duration?: Duration;
}

export interface Discount {
    type: 'none' | 'amount' | 'percentage';
    value: number;
}

export interface ItemData {
    discount: Discount;
    quantity?: number;
    price?: number;
    total?: number;
}

export interface DataVaraible {
    service?: PetServiceWrapper;
    staffId?: number;
    date: Moment;
    type?: itemTypes;
    product?: Product;
    addOn?: AddOnService;
    customDescription?: string;
    itemData?: ItemData;
}

export interface AppointmentMultiple {
    clientId: number;
    petId: number;
    createdByStaffId: number;
    notes?: string;
    variableData: Array<DataVaraible>;
}

export interface AppointmentActions {
    service?: PetServiceWrapper;
    staffId?: number;
    date?: Moment;
    petId?: number;
    discount?: Discount;
    product?: Product;
    addOn?: AddOnService;
    custom?: string;
    type?: itemTypes;
    itemData?: ItemData;
}

export interface AddOnDate {
    id?: number;
    date: string;
}

export enum OrderizableTypes {
    APPOINTMENT = 'appointment',
    ADDON_SERVICE = 'addon_service',
    PRODUCT = 'product',
    CUSTOM = 'custom'
}
